import { useEffect } from "react";
import CharitySelector from "./CharitySelector";
import { useSelector } from "react-redux";
import { useDispatch } from 'react-redux';
import { openAccountSidebar } from "@/redux/actions/loggedInUser";
import PreNotificationPopup from "./PreNotificationPopup";
import CharityPillar from "./CharityPillar";
import LoginLandingScreen from "./LoginLandingScreen";
import { WelcomeJourneyState } from "@/redux/actions/pwaAction";

export default function WelcomeJourney() {
  const dispatch = useDispatch();

  const step =  useSelector((state) => state.pwa.welcome_journey.currentStepNo);;
  const userLoggedIn = useSelector((state) => state.loginUser.userLoggedIn);
  const welcomeJourneyStates = useSelector((state) => state.pwa.welcome_journey);
  const firstVisit = useSelector((state) => state.pwa.firstVisit);
  const accountSidebarOpen = useSelector(
    (state) => state.loginUser.open_account_sidebar
  );

  const changeStep = (currStep) => {
    dispatch(WelcomeJourneyState({...welcomeJourneyStates, currentStepNo: currStep}));
  }

  useEffect(() => {
    if(document.querySelector("#pwa-mobile-header") && welcomeJourneyStates.addWCOverlay && welcomeJourneyStates.currentStepNo <= welcomeJourneyStates.totalSteps && !welcomeJourneyStates.isSkipped && firstVisit){
      document.querySelector("#pwa-mobile-header")?.classList.add("wc_journey");
      document.querySelector("#oli-popup")?.classList.add("d-none"); //for oli popup not to show on welcome journey
      document.querySelector(".oli-chat-bubble-popup")?.classList.add("d-none");
    }
    else {
      document.querySelector("#pwa-mobile-header")?.classList.remove("wc_journey");
      document.querySelector("#oli-popup")?.classList.remove("d-none");
      document.querySelector(".oli-chat-bubble-popup")?.classList.remove("d-none");
    }
  },[welcomeJourneyStates.addWCOverlay]);

  useEffect(() => {
    if(document.querySelector("#pwa-mobile-header") && !userLoggedIn && accountSidebarOpen && welcomeJourneyStates.currentStepNo == 3){
      document.querySelector("#pwa-mobile-header")?.classList.add("wc_jounery_account");
    }
    else {
      document.querySelector("#pwa-mobile-header")?.classList.remove("wc_jounery_account");
    }
  },[accountSidebarOpen]);

 
  return (
    <>

      {welcomeJourneyStates.currentStepNo <= welcomeJourneyStates.totalSteps && !welcomeJourneyStates.isSkipped && (
        <div className={`overlay_wrapper ${step == 4 ? "step4_coloured" : "colored"} ${step == 1||step == 2 || step == 5 ? "fixed-wrapper" : ""}`}>
          <div className="pwa-transition" style={{display: step == 1 ? "block" : "none"}}>
            <PreNotificationPopup changeStep={changeStep}/>
          </div>
          <div className="pwa-transition" style={{display: step == 2 ? "block" : "none"}}>
            <LoginLandingScreen changeStep={changeStep}/>
          </div>
          {/* step 3 for account drawer */}
          <div className="scrolling_section" style={{display: step == 4 ? "block" : "none"}}>
            <CharitySelector changeStep={changeStep} step={step} />
          </div>
          <div className="pwa-transition" style={{display: step == 5 ? "block" : "none"}}>
            <CharityPillar changeStep={changeStep}/>
          </div>
          {/* step 6 to exit welcome journey */}
        </div>
      )}
    </>
  );
}
